import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-relation', {
    mixins: [FormElementMixin],
    props: {
        relationString: {
            type: String,
        },
        bundleId: {
            type: String,
        },
        definitionId: {
            type: String,
        },
        currentObjectId: {
            type: String,
        },
        relation: {
            type: Object,
        },
        baseUri: {
            type: String,
            required: false,
            default: ''
        },
    },
    data() {
        return {
            currentRelation: null
        }
    },
    computed: {
        renderRelationResolver() {
            let relation = this.getActiveRelation();

            if(! relation) {
                return false;
            }

            let fieldId = relation.shift();
            if(fieldId == this.id) {
                return true;
            }
            
            return false;
        },
        currentRelationString() {
            let relation = this.getActiveRelation();
            relation.shift();
            return relation.join(':');
        }
    },
    watch: {
        currentRelation: {
            deep: true,
            handler() {
                this.setCurrentValue(this.currentRelation.selected);
            }
        },
    },
    methods: {
        /**
         *
         * @param data
         */
        async updateRelations(idsSelected) {
            const url = `${this.$appKitUrl()}/${this.bundleId}/${this.definitionId}/select-ids`;

            let param = {
                id: this.currentObjectId,
                foreignIds: idsSelected.join(',')
            };

            try {
                // notify the backend of the selection so we get an updated relation.selected array
                const relation = await this.$get(url, param);
                if(relation) {
                    this.currentRelation = relation;
                }
            } catch (error) {
                console.log(error);
            }
            
        },
        /**
         *
         * @returns {{name: string, params: {}}}
         */
        relationUrl() {

            let params = {};
            params = Object.assign(params, this.$route.params);

            let currentRelationAddon = this.id + ':grid:' + this.bundleId + ':' + this.definitionId;

            if(params.relationString != undefined) {
                params.relationString += ':' + currentRelationAddon;
            } else {
                params.relationString = currentRelationAddon;
            }

            return {
                name: 'form',
                params: params
            }
        },
        /**
         *
         * @returns {*}
         */
        getActiveRelation() {
            let relationString = this.relationString;

            if(! relationString) {
                return false;
            }

            return relationString.split(':');
        },
        /**
         *
         * @param widget
         * @param widgetKey
         * @param item
         * @returns {*}
         */
        addOnWidgetAttributes(widget, widgetKey, item) {
            // if we have a form control we check if we need to set a value
            let out = { ...widget.formControl, ...widget.attributes, id: widget.id, baseUri: this.baseUri };

            // if we hava a value add it
            if(!out.value && item.addOnValues[widgetKey]) {
                out.value = item.addOnValues[widgetKey];
            }

            return out;
        },
        /**
         *
         * @param id
         */
        deleteSelected(id) {
            // remove the item from the selected array
            this.currentRelation.selected = this.currentRelation.selected.filter((item, key) => item.id != id);
        },
        /**
         *
         * @returns {Array}
         */
        selectedIds() {
            return this.currentRelation.selected.length ?
                this.currentRelation.selected.map(item => { return item.id }) :
                [];
        },
        selectedItems() {
            this.currentRelation.selected.forEach((item) => {
                item.widgets = {...this.relation.widgets}
            });

            return this.currentRelation.selected;
        },
        /**
         *
         * @param widgetKey
         * @param item
         * @param value
         */
        handleWidgetInput( widgetKey, item, value) {
            if(!value) return;

            // we can't just set the addOnValues like addOnValues[widgetKey] = value beceause with a new item vue wil not pickup on these changes
            let currentSelection = this.currentRelation.selected.find(selectedItem => selectedItem.id == item.id);
            let addOnValues = {...currentSelection.addOnValues};

            addOnValues[widgetKey] = value;
            currentSelection.addOnValues = addOnValues;
        },
        /**
         *
         * @param id
         * @param values
         */
        async validateAddOnValue(id, values, item) {


            if (!id) return;
            const url = `${this.$appKitUrl()}/${this.bundleId}/${this.definitionId}/validate-add-on`;
            const validateData = {
                "addOnId": id,
                "addOnValues": { ...values }
            };

            try {
                const result = await this.$post(url, validateData);
                let widget = this.currentRelation.selected.find(selectedItem => selectedItem.id == item.id).widgets.addOns.find(item => item.id == id);
                widget.formControl = { ...widget.formControl, ...result[id] };

                // Do something
            } catch (error) {
                console.log(error);
            }
        },
        /**
         *
         * @param selected
         */
        setCurrentValue(selected) {
            let out = [];
            selected.forEach((item, key) => {
                out.push({
                    id: item.id,
                    addOnValues: item.addOnValues
                });

            });
            console.log(out);
            this.currentValue = out;
        }
    },
    created() {
        // we need to disconnect the relation prop from the current relation
        // state otherwise the selected items wil change every time another relation is opened
        this.relation.enableSorting = true;
        this.currentRelation = this.relation;
    }
}, 'form/controls/ak-relation.html');